import React from 'react';

import Tag from '../../common/ui/Tag';

const ContentTypeTag = ({ contentType }) => {
  const type = contentTypes[contentType];
  if (!type) {
    return null;
  }
  const { label, color } = type;
  return <Tag color={color}>{label}</Tag>;
};

const contentTypes = {
  Ecommerce: {
    label: 'ECOMMERCE',
    color: 'purple'
  },
  'Tasting Room': {
    label: 'TASTING ROOM',
    color: 'sky'
  },
  'Wine Club': {
    label: 'WINE CLUB',
    color: 'orange'
  },
  Marketing: {
    label: 'MARKETING',
    color: 'grape'
  },
  'C7 Feature': {
    label: 'C7 FEATURE',
    color: 'green'
  },
  News: {
    label: 'NEWS',
    color: 'blueberry'
  },
  'Case Studies': {
    label: 'CASE STUDIES',
    color: 'grey'
  }
};

export default ContentTypeTag;
